import React, { Component } from 'react'
import '../styles/AllThemesCalendar.css'
import LAIconSmall from '../images/Themes/icon-small-la.png'
import VBNIconSmall from '../images/Themes/icon-small-vbn.png'
import AbattoirIconSmall from '../images/Themes/icon-small-abattoir.png'
import YakuzaIconSmall from '../images/Themes/icon-small-yakuza.png'
import TombeauIconSmall from '../images/Themes/icon-small-tombeau.png'
import { injectIntl, defineMessages } from "react-intl"
import moment from 'moment'
import 'moment/locale/fr'
import utils from '../utils.json'

const weekLimit = utils.weekLimit

const themeCodeBuilder = (code) => {
  switch (code) {
    case '27':
      return 'la'
    case '28':
      return 'vbn'
    case '29':
      return 'abattoir'
    case '31':
      return 'yakuza'
    case '32':
      return 'tombeau'
    default:
      break
  }
}

const stripTimeBegin = (time) => {
  if (time) {
    return time.split(":")[0]
  }
}

const stripMinutes = (time) => {
  return parseInt(time.split(':')[1]) > -1 ? time.split(':')[1] : '';
}

const formatDateToEnglish = (date) => {
  const arr = date.split('/')

  return `${arr[1]}-${arr[0]}-${arr[2]}`
}

const isOverMonthLimit = slotDate => slotDate < moment().add(weekLimit, 'w').subtract(1, 'd')

class AllThemesCalendar extends Component {

  handleClick = (data) => {
    if (!data.target.className.includes("selected")) {
      this.props.handleClick(data.target.id)
    }
  }

  getRoomSlots = (idRoom) => {
    if (this.props.slots.filter(x => x.id_room === idRoom).shift().calendar.length > 0) {
      return this.props.slots.filter(x => x.id_room === idRoom).shift().calendar
    } else {
      return emptyCalendar
    }
  }

  stripHours = (time) => {
    return time.split(':').shift()
  }

  buildSlotCode = (booking, withMinutes) => {
    if (withMinutes)
      return `${themeCodeBuilder(booking.room_id)}|${booking.reservation_date}|${stripTimeBegin(booking.time_begin)}|${stripMinutes(booking.time_begin)}`
    else
      return `${themeCodeBuilder(booking.room_id)}|${booking.reservation_date}|${stripTimeBegin(booking.time_begin)}`
  }

  formatDate = (date) => {
    const formattedDate = date.format('l').split("/")
    let y, M, d

    y = formattedDate[2]
    M = formattedDate[1].length < 2 ? `0${formattedDate[1]}` : formattedDate[1]
    d = formattedDate[0].length < 2 ? `0${formattedDate[0]}` : formattedDate[0]

    if (this.props.lang === "fr") {
      return `${y}-${M}-${d}`
    } else {
      return `${y}-${d}-${M}`
    }
  }

  checkAvailability = (slot) => {
    const minutesBefore = Number.isFinite(Number(slot.minutes_before_reservation)) ? Number(slot.minutes_before_reservation) : 60
    const inOneHour = moment().add(minutesBefore, 'minute')
    const date = this.props.lang === "fr" ? this.props.date.format('L') : formatDateToEnglish(this.props.date.format('L'))
    const hour = slot.time_begin
    const slotDate = moment(date + ' ' + hour, 'DD/MM/YYYY HH:mm:ss')
    return inOneHour < slotDate && isOverMonthLimit(slotDate)
  }

  updateCells = () => {

    document.querySelectorAll("td").forEach(td => {
      td.classList.remove("theme-calendar--selected")
    })

    if (this.props.selectedSlots.length > 0) {
      this.props.selectedSlots.forEach(booking => {
        let formattedSlot = this.buildSlotCode(booking, false)
        const selectedCell = document.querySelectorAll(`[id^='${formattedSlot}']`)
        formattedSlot = this.buildSlotCode(booking, true)
        if (selectedCell.length > 0) {
          const themeCode = themeCodeBuilder(booking.room_id)
          selectedCell[0].classList.add("theme-calendar-cell-all", "theme-calendar--selected", `theme-calendar-cell-all--${themeCode}`)
          selectedCell[0].onclick = (data) => this.handleClick(data)
          selectedCell[0].classList.remove("theme-calendar-unavailable")
          selectedCell[0].innerHTML = ""
          selectedCell[0].insertAdjacentHTML("afterBegin", `${formattedSlot.split("|")[2]}:${formattedSlot.split("|")[3]}`)
        }
      })
    }
  }

  componentDidMount() {
    this.updateCells()
  }

  componentDidUpdate() {
    this.updateCells()
  }

  render() {
    const {intl:{formatMessage}} = this.props
    let maxSlots = 0;
    this.props.slots.forEach((slot) => {
      if (slot.calendar)
        slot.calendar.length > maxSlots ? maxSlots = slot.calendar.length : null;
    });
    maxSlots++; // Header
    maxSlots++; // Header

    return (
      <table className="theme-calendar theme-calendar--all">
        <thead className="theme-calendar-header theme-calendar-header--all">
          <tr>
            <th colSpan={maxSlots}>
              <span>One Hour Charonne</span> / 24 rue Emile Lepeu 75011 Paris
            </th>
          </tr>
        </thead>
        <tbody className="theme-calendar-body theme-calendar-body--all">
          <tr className="theme-calendar-row--la">
            <td className="theme-calendar-row-pre theme-calendar-row-pre--la"></td>
            <td className="theme-calendar-theme-name">
              <div style={{ display: "flex", alignItems: "center"}}>
                {formatMessage(messages.la)}
              </div>
            </td>
           {
              Object.keys(this.getRoomSlots("27")).map( (x, i) =>
                this.getRoomSlots("27")[x].bookable && this.checkAvailability(this.getRoomSlots("27")[x])
                ? <td
                    key={i}
                    id={`la|${this.formatDate(this.props.date)}|${this.stripHours(this.getRoomSlots("27")[x].time_begin)}|${this.stripHours(this.getRoomSlots("27")[x].id_room_calendar)}|${stripMinutes(this.getRoomSlots("27")[x].time_begin)}`}
                    className="theme-calendar-cell-all theme-calendar-cell-all--la"
                    onClick={ data => this.handleClick(data)}>{`${this.stripHours(this.getRoomSlots("27")[x].time_begin)}:${stripMinutes(this.getRoomSlots("27")[x].time_begin)}`}</td>
                : <td
                    key={i}
                    id={`la|${this.formatDate(this.props.date)}|${this.stripHours(this.getRoomSlots("27")[x].time_begin)}|${this.stripHours(this.getRoomSlots("27")[x].id_room_calendar)}|${stripMinutes(this.getRoomSlots("27")[x].time_begin)}`}
                    className="theme-calendar-unavailable"></td>
              )
            }
          </tr>
          <tr className="theme-calendar-row--vbn">
            <td className="theme-calendar-row-pre theme-calendar-row-pre--vbn"></td>
            <td className="theme-calendar-theme-name">
              <div style={{ display: "flex", alignItems: "center"}}>
                {formatMessage(messages.VBN)}
              </div>
            </td>
            {
               Object.keys(this.getRoomSlots("28")).map( (x, i) =>
                 this.getRoomSlots("28")[x].bookable && this.checkAvailability(this.getRoomSlots("28")[x])
                 ? <td
                  key={i}
                  id={`vbn|${this.formatDate(this.props.date)}|${this.stripHours(this.getRoomSlots("28")[x].time_begin)}|${this.stripHours(this.getRoomSlots("28")[x].id_room_calendar)}|${stripMinutes(this.getRoomSlots("28")[x].time_begin)}`}
                  className="theme-calendar-cell-all theme-calendar-cell-all--vbn"
                  onClick={ data => this.handleClick(data)}>{`${this.stripHours(this.getRoomSlots("28")[x].time_begin)}:${stripMinutes(this.getRoomSlots("28")[x].time_begin)}`}</td>
                 : <td
                  key={i}
                  id={`vbn|${this.formatDate(this.props.date)}|${this.stripHours(this.getRoomSlots("28")[x].time_begin)}|${this.stripHours(this.getRoomSlots("28")[x].id_room_calendar)}|${stripMinutes(this.getRoomSlots("28")[x].time_begin)}`}
                  className="theme-calendar-unavailable"></td>
               )
             }
          </tr>
        </tbody>
        <thead className="theme-calendar-header theme-calendar-header--all">
          <tr>
            <th colSpan={maxSlots}>
              <span>One Hour Voltaire</span> / 23 rue Servan 75011 Paris
            </th>
          </tr>
        </thead>
        <tbody className="theme-calendar-body theme-calendar-body--all">
          <tr className="theme-calendar-row--abattoir">
            <td className="theme-calendar-row-pre theme-calendar-row-pre--abattoir"></td>
            <td className="theme-calendar-theme-name">
              <div style={{ display: "flex", alignItems: "center"}}>
                {formatMessage(messages.slaughterhouse)}
              </div>
            </td>
            {
               Object.keys(this.getRoomSlots("29")).map( (x, i) =>
                 this.getRoomSlots("29")[x].bookable && this.checkAvailability(this.getRoomSlots("29")[x])
                 ? <td
                  key={i}
                  id={`abattoir|${this.formatDate(this.props.date)}|${this.stripHours(this.getRoomSlots("29")[x].time_begin)}|${this.stripHours(this.getRoomSlots("29")[x].id_room_calendar)}|${stripMinutes(this.getRoomSlots("29")[x].time_begin)}`}
                  className="theme-calendar-cell-all theme-calendar-cell-all--abattoir"
                  onClick={ data => this.handleClick(data)}>{`${this.stripHours(this.getRoomSlots("29")[x].time_begin)}:${stripMinutes(this.getRoomSlots("29")[x].time_begin)}`}</td>
                 : <td
                  key={i}
                  id={`abattoir|${this.formatDate(this.props.date)}|${this.stripHours(this.getRoomSlots("29")[x].time_begin)}|${this.stripHours(this.getRoomSlots("29")[x].id_room_calendar)}|${stripMinutes(this.getRoomSlots("29")[x].time_begin)}`}
                  className="theme-calendar-unavailable"></td>
               )
             }
          </tr>
        </tbody>
        <tbody className="theme-calendar-body theme-calendar-body--all">
          <tr className="theme-calendar-row--yakuza">
            <td className="theme-calendar-row-pre theme-calendar-row-pre--yakuza"></td>
            <td className="theme-calendar-theme-name">
              <div style={{ display: "flex", alignItems: "center"}}>
                {formatMessage(messages.yakuza)}
              </div>
            </td>
            {
               Object.keys(this.getRoomSlots("31")).map( (x, i) =>
                 this.getRoomSlots("31")[x].bookable && this.checkAvailability(this.getRoomSlots("31")[x])
                 ? <td
                  key={i}
                  id={`yakuza|${this.formatDate(this.props.date)}|${this.stripHours(this.getRoomSlots("31")[x].time_begin)}|${this.stripHours(this.getRoomSlots("31")[x].id_room_calendar)}|${stripMinutes(this.getRoomSlots("31")[x].time_begin)}`}
                  className="theme-calendar-cell-all theme-calendar-cell-all--yakuza"
                  onClick={ data => this.handleClick(data)}>{`${this.stripHours(this.getRoomSlots("31")[x].time_begin)}:${stripMinutes(this.getRoomSlots("31")[x].time_begin)}`}</td>
                 : <td
                  key={i}
                  id={`yakuza|${this.formatDate(this.props.date)}|${this.stripHours(this.getRoomSlots("31")[x].time_begin)}|${this.stripHours(this.getRoomSlots("31")[x].id_room_calendar)}|${stripMinutes(this.getRoomSlots("31")[x].time_begin)}`}
                  className="theme-calendar-unavailable"></td>
               )
             }
          </tr>
        </tbody>
        <tbody className="theme-calendar-body theme-calendar-body--all">
          <tr className="theme-calendar-row--tombeau">
            <td className="theme-calendar-row-pre theme-calendar-row-pre--tombeau"></td>
            <td className="theme-calendar-theme-name">
              <div style={{ display: "flex", alignItems: "center", textAlign: "left"}}>
                {formatMessage(messages.tombeau)}
              </div>
            </td>
            {
               Object.keys(this.getRoomSlots("32")).map( (x, i) =>
                 this.getRoomSlots("32")[x].bookable && this.checkAvailability(this.getRoomSlots("32")[x])
                 ? <td
                  key={i}
                  id={`tombeau|${this.formatDate(this.props.date)}|${this.stripHours(this.getRoomSlots("32")[x].time_begin)}|${this.stripHours(this.getRoomSlots("32")[x].id_room_calendar)}|${stripMinutes(this.getRoomSlots("32")[x].time_begin)}`}
                  className="theme-calendar-cell-all theme-calendar-cell-all--tombeau"
                  onClick={ data => this.handleClick(data)}>{`${this.stripHours(this.getRoomSlots("32")[x].time_begin)}:${stripMinutes(this.getRoomSlots("32")[x].time_begin)}`}</td>
                 : <td
                  key={i}
                  id={`tombeau|${this.formatDate(this.props.date)}|${this.stripHours(this.getRoomSlots("32")[x].time_begin)}|${this.stripHours(this.getRoomSlots("32")[x].id_room_calendar)}|${stripMinutes(this.getRoomSlots("32")[x].time_begin)}`}
                  className="theme-calendar-unavailable"></td>
               )
             }
          </tr>
        </tbody>
      </table>
    )
  }
}

const messages = defineMessages({
  la: {
    id: 'themes.la',
    defaultMessage: 'lost asylum'
  },
  VBN: {
    id: 'themes.VBN',
    defaultMessage: 'Very Bad Night'
  },
  slaughterhouse: {
    id: 'themes.slaughterhouse',
    defaultMessage: "L'abattoir"
  },
  yakuza: {
    id: 'themes.yakuza',
    defaultMessage: "Yakuza"
  },
  tombeau: {
    id: 'themes.tombeau',
    defaultMessage: "Expédition Maudite"
  },
})

const emptyCalendar = [
  {
  already_booked_for: "0",
  time_begin: "10:00:00",
  time_end: "12:00:00",
  id_room_calendar: "67",
  normal_price_type: "c",
  other_price_type: null,
  necessary_resource_quantity: "1",
  company_id: "30",
  global_price: "c",
  min_nb_resource_available: "-1",
  bookable: false,
  quantity_resource_booked: "0"
  },
  {
  already_booked_for: "0",
  time_begin: "12:00:00",
  time_end: "14:00:00",
  id_room_calendar: "68",
  normal_price_type: "c",
  other_price_type: null,
  necessary_resource_quantity: "1",
  company_id: "30",
  global_price: "c",
  min_nb_resource_available: "-1",
  bookable: false,
  quantity_resource_booked: "0"
  },
  {
  already_booked_for: "0",
  time_begin: "14:00:00",
  time_end: "16:00:00",
  id_room_calendar: "69",
  normal_price_type: "c",
  other_price_type: null,
  necessary_resource_quantity: "1",
  company_id: "30",
  global_price: "c",
  min_nb_resource_available: "-1",
  bookable: false,
  quantity_resource_booked: "0"
  },
  {
  already_booked_for: "0",
  time_begin: "16:00:00",
  time_end: "18:00:00",
  id_room_calendar: "70",
  normal_price_type: "c",
  other_price_type: null,
  necessary_resource_quantity: "1",
  company_id: "30",
  global_price: "c",
  min_nb_resource_available: "-1",
  bookable: false,
  quantity_resource_booked: "0"
  },
  {
  already_booked_for: "0",
  time_begin: "18:00:00",
  time_end: "20:00:00",
  id_room_calendar: "71",
  normal_price_type: "p",
  other_price_type: null,
  necessary_resource_quantity: "1",
  company_id: "30",
  global_price: "p",
  min_nb_resource_available: "-1",
  bookable: false,
  quantity_resource_booked: "0"
  },
  {
  already_booked_for: "0",
  time_begin: "20:00:00",
  time_end: "22:00:00",
  id_room_calendar: "72",
  normal_price_type: "p",
  other_price_type: null,
  necessary_resource_quantity: "1",
  company_id: "30",
  global_price: "p",
  min_nb_resource_available: "-1",
  bookable: false,
  quantity_resource_booked: "0"
  },
  {
  already_booked_for: "0",
  time_begin: "22:00:00",
  time_end: "23:59:00",
  id_room_calendar: "73",
  normal_price_type: "p",
  other_price_type: null,
  necessary_resource_quantity: "1",
  company_id: "30",
  global_price: "p",
  min_nb_resource_available: "-1",
  bookable: false,
  quantity_resource_booked: "0"
  }
]

export default injectIntl(AllThemesCalendar)



// WEBPACK FOOTER //
// ./src/components/AllThemesCalendar.js